import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import type { Permission } from '../../types';
import type { PermissionModel } from '../permission-model';

@injectable()
export class PermissionModelImpl extends AbstractModel<Permission> implements PermissionModel {
    protected _modelData: Permission = {
        addToWorkspace: false,
        advanceSearch: false,
        authorizationForecast: false,
        cas: false,
        chemical: false,
        citation: false,
        citationMap: false,
        claimTree: false,
        commentAndField: false,
        commentFlag: false,
        companySpace: false,
        comparePatent: false,
        customFieldFlag: false,
        customsData: false,
        discovery: false,
        email: false,
        export: false,
        family: false,
        familyGeo: false,
        familyTree: false,
        figure: false,
        fileWrapper: false,
        fileWrapperAdvance: false,
        fileWrapperAlert: false,
        fileWrapperModify: false,
        fullText: false,
        imageDiscovery: false,
        insights: false,
        legal: false,
        licensing: false,
        lifeScience: false,
        litigation: false,
        mlt: false,
        paper: false,
        patentValue: false,
        pdf: false,
        pdfDownload: false,
        pledge: false,
        reexamInvalid: false,
        semantic: false,
        sep: false,
        share: false,
        similarParagraph: false,
        simpleSearch: false,
        textCompare: false,
        vpm: false,
        workspaceDelete: false,
        claimCompare: false,
        claimSeparate: false,
    };
}
